import { buildComponent } from 'src/components/factory'

import { useStoreState } from 'src/hooks/state'
import { usePendingRedirect } from 'src/hooks/use-pending-redirect'
import { useNavigationState } from '@react-navigation/native'

export const NoSpaceDetection = buildComponent().withLifecycle(() => {
  const routeName = useNavigationState((state) => {
    const route = state?.routes[state?.index ?? 0]
    return route?.name ?? ''
  })
  const loaded = useStoreState((store) => store.space.loaded)
  const spaces = useStoreState((store) => store.space.all)

  usePendingRedirect(
    loaded && !spaces.length && routeName !== '/account/spaces',
    '/account/spaces',
    {},
    true,
  )
})
